export const cssHeight = (height) => {
  return `height:${height}px;`;
};

export { default as ArrowPlusDown } from './ArrowPlusDown';
export { default as ArrowPlusUp } from './ArrowPlusUp';
